import React, { useEffect, useState } from 'react';
import './Header.css';

const Header = () => {
  const [scrollClass, setScrollClass] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 0) {
        setScrollClass('scrolled');
      } else {
        setScrollClass('');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header id='home' className={`header ${scrollClass}`}>
      <nav className={`nav ${menuOpen ? 'open' : ''}`}>
        <div className='nav_menu'>
          <ul className='nav_list grid'>
            <li className='nav_item'>
              <a href='#home' className='nav_link active_link' onClick={closeMenu}>
                <i className='uil uil-estate nav_icon'></i> Home
              </a>
            </li>
            <li className='nav_item'>
              <a href='#info' className='nav_link' onClick={closeMenu}>
                <i className='uil uil-file-alt nav_icon'></i> Info
              </a>
            </li>
            <li className='nav_item'>
              <a href='#gallery' className='nav_link' onClick={closeMenu}>
                <i className='uil uil-user nav_icon'></i> Gallery
              </a>
            </li>
            <li className='nav_item'>
              <a href='#videotour' className='nav_link' onClick={closeMenu}>
                <i className='uil uil-briefcase nav_icon'></i> Video Tour
              </a>
            </li>
            <li className='nav_item'>
              <a href='#contact' className='nav_link' onClick={closeMenu}>
                <i className='uil uil-message nav_icon'></i> Contact
              </a>
            </li>
          </ul>

          <i className='uil uil-times nav_close' onClick={toggleMenu}></i>
        </div>

        <div className='nav_toggle' onClick={toggleMenu}>
          <i className={`uil uil-${menuOpen ? 'times' : 'apps'}`}></i>
        </div>
      </nav>

      <div className='intro section'>
        <h1 className='intro-title'>Welcome Home, Your Dream Home Awaits!</h1>
        <div className='address'>2 Franklin Ave, London, ON N6C 2G7</div>
        <div className='general-information'>
          • 2 Living Rooms • 4 Bedrooms • 3 Bathrooms • 1 Garage
        </div>
        <div className='price'>$ 1,130,000</div>
      </div>
    </header>
  );
};

export default Header;
